import BaseModel from './Base.model';
import { PurchaseOrderModel } from './PurchaseOrder.model';

/**
 * Hydrate response /purchase-order/share/:id của BE.
 * BE trả Cha kèm `children[]` (mỗi child có store + details).
 * Model expose:
 *  - Flat field cho view binding: providerName, createdByName
 *  - `children`: array PurchaseOrderModel (PO Con)
 *  - `inventories`: derived shape mà grid POShare.vue cần (store + products)
 */
export class PurchaseOrderShareModel extends PurchaseOrderModel {
  constructor(data = {}) {
    super(data);

    this.providerName = data.provider?.name || data.providerName || '';
    this.createdByName =
      data.createdByUser?.fullName || data.createdByName || '';

    this.children = (data.children || []).map(
      (c) => new PurchaseOrderModel(c),
    );

    this.inventories = (data.children || []).map((c) => ({
      id: c.id,
      storeId: c.storeId,
      name: c.store?.name || '',
      shortName: c.store?.shortName || '',
      products: (c.details || []).map((d) => ({
        productId: d.productId,
        productName: d.product?.name || '',
        productCode: d.product?.code || '',
        quantity: Number(d.quantity) || 0,
        quantityApprove: Number(d.quantityApprove) || 0,
      })),
    }));
  }
  static fromJson(d) {
    return BaseModel.fromJson(d, PurchaseOrderShareModel);
  }
  static fromJsonArray(a) {
    return BaseModel.fromJsonArray(a, PurchaseOrderShareModel);
  }
}
